import React, { Component } from 'react';
import Constants from '../../Config/Config';
import Parser from 'html-react-parser';

class Printing extends Component {

	componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedPrint !== this.props.selectedPrint || prevProps.windowSizes !== this.props.windowSizes || prevProps.matPrint !== this.props.matPrint) {
      this.getSelectedPrint();
  	}
	}

  getSelectedPrint = () => {
    const { printing, selectedPrint, matBoardWindowSize, windowSizes, matPrint } = this.props;
    if (printing.size > 0 && selectedPrint !== null) {
      var windowWidth = 0;
      var windowHeight = 0;
      for (var i = 0; i < matBoardWindowSize; i++) {
        if (matPrint.size > 0) {
          if (matPrint.getIn([i, 'print']).includes('yes')) {
            windowWidth += parseFloat(windowSizes.getIn([i, 'width']));
            windowHeight += parseFloat(windowSizes.getIn([i, 'height']));
          }
        }
      }

      var windowTotalDimensions = windowWidth + windowHeight;

      //console.log(windowTotalDimensions)

      printing.filter( ( print ) =>
        parseFloat(selectedPrint) === print.get('id')
      ).map( ( print ) =>
        this.props.dispatch({
          type: 'SET_STATE',
          state: {
            printTotal: ( windowTotalDimensions * parseFloat(print.getIn(['acf', 'price'])) ).toFixed(2),
            selectedPrintName: print.getIn(['title', 'rendered'])
          }
        })
      )
    }
  };

	render() {
		const {printTotal, selectedPrintName} = this.props;
    return (
      <tr>
  			<th>Printing</th>
  			<td>{selectedPrintName !== null ? Parser(selectedPrintName) : ''}</td>
  			<td>{Constants.Currency + printTotal}</td>
      </tr>
    );
	}
}

export default Printing;